import styled from 'styled-components';

import Workflow from 'models/Workflow';
import { colors } from 'styles/theme/colors';
import { BodySmall, BodySmallBold } from 'styles/typography';

import { IDENTITY_VALUES, labelForValue } from './actionConfig';

// The demographics the AI landed, shown inside the completed Extract Demographics
// action. The richer candidates/confidence design is still pending.
export default function ExtractionResults({ workflow }: { workflow: Workflow }) {
  const rows = IDENTITY_VALUES.map((name) => ({ name, value: workflow.valueFor(name)?.value })).filter(
    (row) => !!row.value
  );
  if (rows.length === 0) return null;

  return (
    <Rows data-testid='extraction-results'>
      {rows.map((row) => (
        <Row key={row.name}>
          <Label>{labelForValue(workflow, row.name)}</Label>
          <Value>{row.value}</Value>
        </Row>
      ))}
    </Rows>
  );
}

const Rows = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
`;

const Row = styled.div`
  min-width: 120px;
`;

const Label = styled(BodySmall)`
  display: block;
  color: ${colors.black50};
  font-size: 11px;
`;

const Value = styled(BodySmallBold)`
  color: ${colors.black};
`;
